const styles = {
  global: {
    html: { scrollBehavior: 'smooth' },
    body: {
      bg: 'chakra-body-bg',
      color: 'chakra-body-text',
      lineHeight: 'normal',
      transitionProperty: 'background-color',
      transitionDuration: 'normal',
      maxW: '100vw !important', // CDP-514 - prevent overflow in iframe on iOS - https://stackoverflow.com/questions/49749442/workaround-to-ios-11-webkit-iframe-bugs
    },
    h1: { mb: 4 },
    '*::placeholder': {
      color: 'chakra-placeholder-color',
    },
    '*, *::before, &::after': {
      borderColor: 'chakra-border-color',
      wordWrap: 'break-word',
      borderWidth: 0,
    },
  },
};

export default styles;
